import { createClient } from '@supabase/supabase-js'
import { mockSupabase } from './mockSupabase'

const realSupabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  { multiTab: false }
)

export const supabase = process.env.REACT_APP_USE_MOCK === 'true' ? mockSupabase : realSupabase